package com.shadowings.gero.presentation.screen.characters

import com.shadowings.gero.presentation.util.DevicePreviews
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.ui.AppTheme

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun ColorSectionPreview() {
    AppTheme {
        Surface {
            ColorSection(
                title = "Esempio",
                options = backgroundOptions,
                selectedIndex = 0,
                onSelect = {}
            )
        }
    }
}

@Composable
fun ColorSection(
    title: String,
    options: List<Color>,
    selectedIndex: Int,
    onSelect: (Int) -> Unit,
    modifier: Modifier = Modifier,
) {
    if (title.isNotBlank()) {
        Text(
            text = title,
            style = MaterialTheme.typography.titleMedium,
            modifier = Modifier
                .fillMaxWidth()
                .wrapContentWidth(Alignment.CenterHorizontally)
        )

        Spacer(Modifier.height(6.dp))
    }

    Spacer(Modifier.height(4.dp))

    val sectionKey = title.lowercase().replace(" ", "_").filter { it.isLetterOrDigit() || it == '_' }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .horizontalScroll(rememberScrollState())
            .padding(horizontal = 8.dp),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        options.forEachIndexed { idx, option ->
            ColorDot(
                color = option,
                selected = idx == selectedIndex,
                onClick = { onSelect(idx) },
                tag = "color_dot_${sectionKey}_$idx"
            )
            Spacer(Modifier.size(10.dp))
        }
    }
}

